import React from 'react';

const IconEmail = () => (
    <svg version="1" viewBox="0 0 100 75.422">
        <path d="M100 75.422H0V0h100v75.422zm-88.167-6.977h76.333L63.048 42.73l-4.756 4.787c-2.06 2.058-5.007 3.236-8.105 3.236l-.052-.003c-3.11-.013-6.067-1.216-8.115-3.304l-4.835-4.895-25.352 25.896zM6.977 11.973v51.46L32.282 37.59 6.977 11.973zM67.964 37.78l25.06 25.65V12.55l-25.06 25.23zM11.85 6.98l35.14 35.57c.76.774 1.916 1.218 3.174 1.22h.02c1.24 0 2.422-.437 3.162-1.18L88.722 6.978H11.85z"></path>
    </svg>
);

export default IconEmail;